import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SPORTS_FULL_URL: InjectionToken<string> = new InjectionToken<string>('sportsFullUrl');
